import noScroll from "@/utils/noScroll.js";

export default function popup(element, data) {
    const popupId = data.popupId;
    if (!popupId) {
        return;
    }

    const target = document.getElementById(popupId);
    if (!target) {
        return;
    }

    const className = data.class || "open";
    const closeSelector = data.closeSelector || "[data-popup-close]";

    let isOpen = false;

    function open() {
        if (isOpen) {
            return;
        }
        isOpen = true;
        target.classList.add(className);
        noScroll.hideScroll();
    }

    function close() {
        if (!isOpen) {
            return;
        }
        isOpen = false;
        target.classList.remove(className);
        noScroll.showScroll();
    }

    element.addEventListener("click", open);

    target.addEventListener("click", function (event) {
        if (event.target === target) {
            close();
            return;
        }
        if (event.target.closest(closeSelector)) {
            close();
        }
    });
}
